module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Seven years ago, my friend Michael Hyatt encouraged me to write a book—a book that would be a message of hope and healing to more than just one patient at a time. Seven years later, you are holding the final product of a true labor of love. I hope you love it as much as I do. I am a living example of how you can reverse the disease process. I want you to know that you are NOT broken, you were NEVER broken, and your body is designed to heal itself. You simply need a plan, and I have that for you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book would not be possible without so many people, too many to mention:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To my four best friends that I have had for decades, who are the true definition of community. Margo, Trish, Kim, and Billie—you are the roots that keep me standing and hold me accountable.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To my incredible office staff that is truly a “dream team.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To my community in Middle Tennessee that show up, show out, and share your life with me.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To Jen Lill Brown for putting my words so beautifully to paper and pressing on to get this book to print.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To Morgan James Publishing for taking a chance on an unknown author. I won’t let you down.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To Mom, your life was never easy. Alzheimer’s has taken its toll on you. I wish we could have known each other better. I will make the most of whatever time we have left to learn about each other.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To Dad and DeeDee, let’s get the RV geared up for the Wild & Well Book Tour! Thanks for always being there for me.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hang in there, ladies and gentlemen, because the best is yet to come! You got this.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stay Wild & Well,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/fig3.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06efab8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 75
// module chunks = 0